import RCPagination, {
  PaginationProps as RCPaginationProps
} from 'rc-pagination'
import { MdChevronLeft, MdChevronRight } from 'react-icons/md'

const LOCALE = {
  prev_page: 'Previous page',
  next_page: 'Next page'
}

export interface PaginationRebrandProps {
  count: number
  onChange: RCPaginationProps['onChange']
  page: number
  pageSize: number
  showQuickJumper?: boolean
}

export const PaginationRebrand = ({
  count,
  page,
  pageSize,
  onChange,
  showQuickJumper = false
}: PaginationRebrandProps) => {
  return count && page && pageSize ? (
    <div className='my-6'>
      <RCPagination
        current={page}
        jumpNextIcon={<span aria-hidden>…</span>}
        jumpPrevIcon={<span aria-hidden>…</span>}
        locale={LOCALE}
        nextIcon={<MdChevronRight />}
        onChange={onChange}
        pageSize={pageSize}
        prefixCls='rc-pagination-rebrand'
        prevIcon={<MdChevronLeft />}
        total={count}
        showQuickJumper={showQuickJumper && { goButton: 'Go to page' }}
      />
    </div>
  ) : null
}
